import { render } from "./AvatarUploader.vue?vue&type=template&id=7772d8e8&scoped=true"
import script from "./AvatarUploader.vue?vue&type=script&lang=js"
export * from "./AvatarUploader.vue?vue&type=script&lang=js"

import "./AvatarUploader.vue?vue&type=style&index=0&id=7772d8e8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7772d8e8"]])

export default __exports__